import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from 'app/components/ui/alert-dialog';
import { Button } from 'app/components/ui/button';
import { useCurrenciesSlice } from '../slice';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useToast } from 'app/components/ui/use-toast';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: any;
}
export function DeleteDialog({ isOpen, onOpenChange, data }: Props) {
  const { useDeleteCurrencyMutation } = useCurrenciesSlice();
  const [
    deleteCurrency,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteCurrencyMutation();
  const { toast } = useToast();

  const handleDelete = () => {
    deleteCurrency({ currency: data.currency_code });
  };

  useEffect(() => {
    if (deleteError) {
      toast({
        title: deleteError?.data?.message,
        variant: 'destructive',
      });
    }
  }, [deleteError]);

  useEffect(() => {
    if (deletedData) {
      toast({
        title: deletedData?.message,
        variant: 'success',
      });
      onOpenChange(false);
    }
  }, [deletedData]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete your
            account and remove your data from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
